module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACYAAAAdCAYAAADGgB7AAAAA+UlEQVRYR+2VIU6DQRSEZzZbKrkBBhK6pp40HAAOwN9qLKkpCVygByjpX1vXpJYL4BEoEgyIWoIgYH92qmqbbLqkT+zq2fdmvp1kGfr1AlIPZg5/Bd0zVLXMeNoYoZ4ZqukK4JEpc8IdTy4e2v6QZ5A7cNTfPg2SbMWoz7flzQv3aWTb7mIs9WUKsUIslUCq3nbHTgezrm/kGs+Ymiynng1a3jXfr8vhB0M1ewd0nHPBrrMk3Jr8xAk8sXNVjwBd7poy1306fkVybLv8udLmnFOIpdIsxAqxVAKpersdC/36GtB5aqL/0kv48YgTk3+lpEebxqC52Y6tAXYDRC+I49gtAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/navigation_m.png
// module id = klhf
// module chunks = 9